import React, { useMemo } from "react";
import { useFormikContext } from "formik";
import { Label, MultiSelect } from "../../../../../modules/primitives";
import SectionStepFields from "../sectionStepFields";
import { flat } from "../../../../helper";

const StepWrapper = ({
  stepDetails,
  topics,
  industries,
  selectedCouncil,
  instructions,
  setNextStage,
  nextStage,
}) => {
  const formikProps = useFormikContext();

  const technologiesOption = useMemo(
    () => flat(topics, "children_topics"),
    [topics]
  );
  const industriesOption = useMemo(
    () => flat(industries, "children_industries"),
    [industries]
  );

  return (
    <div>
      {stepDetails.isFirstStep && (
        <>
          <h4 className="bold">Submit Idea</h4>
          <h6>{instructions}</h6>
        </>
      )}
      {!stepDetails.isFirstStep && (
        <>
          <h4 className="bold">{stepDetails.name}</h4>
        </>
      )}
      <SectionStepFields
        isFirstStep={stepDetails.isFirstStep}
        step={stepDetails.step}
        setNextStage={setNextStage}
        nextStage={nextStage}
        selectedCouncil={selectedCouncil}
      />
      {stepDetails.isLastAreaOfFocus && (
        <>
          <div>
            <Label>Technology</Label>
            <MultiSelect
              name="topic_ids"
              placeholder="Select"
              labelField="name"
              valueField="id"
              searchBy="name"
              options={technologiesOption}
              formProps={formikProps}
            />
          </div>
          {selectedCouncil?.name !== "Ford" && (
            <div>
              <Label>
                {selectedCouncil?.name === "Freddie Mac"
                  ? "Housing Cycle"
                  : "Industries"}
              </Label>
              <MultiSelect
                name="industry_ids"
                placeholder="Select"
                labelField="name"
                valueField="id"
                searchBy="name"
                options={industriesOption}
                formProps={formikProps}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default React.memo(StepWrapper);
